import { Injectable } from '@angular/core'
import { AddRentalDialogComponent } from '@tv3/containers/rentals/add/add-rental-dialog.component'
import { DialogService, selectAllRentals, selectOnce } from '@tokeet-frontend/tv3-platform'
import { SubscriptionPermissionCheckerService } from '@tv3/services/subscription-permission-checker.service'
import { select, Store } from '@ngrx/store'
import { filter, switchMap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class AddRentalDialogService {
  constructor(
    private dialog: DialogService,
    private store: Store<any>,
    private subscriptionPermissionCheckerService: SubscriptionPermissionCheckerService
  ) {}

  public open() {
    return this.store.pipe(
      selectOnce(selectAllRentals),
      switchMap((rentals) =>
        this.subscriptionPermissionCheckerService.check({
          checkAddRentalPermission: true,
          rentals: rentals ? rentals.length : 0,
        })
      ),
      filter((enabled) => enabled),
      switchMap(() => this.dialog.openDrawer(AddRentalDialogComponent).afterClosed())
    )
  }
}
